export default __webpack_public_path__ + "static/media/new_ad.32a03c41.jpg";